import React from 'react';

const SvgAlertAgenda = (props) => (
  <svg width={24} height={24} {...props}>
    <defs>
      <path
        id="alert-agenda_svg__a"
        d="M6 2v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-1V2h-2v2H8V2H6zM5 9h14v11H5V9z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="alert-agenda_svg__b" fill="currentColor">
        <use xlinkHref="#alert-agenda_svg__a" />
      </mask>
      <use
        fill="currentColor"
        fillRule="nonzero"
        xlinkHref="#alert-agenda_svg__a"
      />
      <g fill="currentColor" mask="url(#alert-agenda_svg__b)">
        <path d="M0 0h24v24H0z" />
      </g>
    </g>
  </svg>
);

export default SvgAlertAgenda;
